import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import environment from '@environment';
import { WiseIdAuthServiceManager } from '../../controller/wise-id-auth.service-manager';

@Component({
  selector: 'app-login-page',
  templateUrl: 'login-page.component.html',
  styleUrls: ['login-page.component.scss'],
  standalone: true,
  imports: [CommonModule]
})
export class LoginPageComponent implements OnInit {

  private readonly ssoLoginUsernamePasswordUrl: string;
  private readonly ssoLoginQRCodePresentationUrl: string;

  constructor(wiseIdService: WiseIdAuthServiceManager) {
    const loginByURL = new URL(environment.SSO_LOGIN_USERNAME_PASSWORD_URL)
    const loginByQR = new URL(environment.SSO_LOGIN_QRCODE_PRESENTATION_URL)

    loginByURL.searchParams.set("redirect_uri",wiseIdService.redirectUrl)
    loginByQR.searchParams.set("redirect_uri",wiseIdService.redirectUrl)

    this.ssoLoginQRCodePresentationUrl = loginByQR.toString()
    this.ssoLoginUsernamePasswordUrl = loginByURL.toString()
  }

  ngOnInit() {
  }

  loginWithUsernamePassword() {
    window.location.href = this.ssoLoginUsernamePasswordUrl;
  }

  loginWithQRCode() {
    window.location.href = this.ssoLoginQRCodePresentationUrl;
  }


}
